export interface NavChild {
  label: string;
  icon: string;
  route: string;
  module?: string;
  exact?: boolean;
}

export interface NavGroup {
  key: string;
  label: string;
  icon: string;
  color: string;
  basePaths: string[];
  modules: string[];
  children: NavChild[];
}

export const NAV_GROUPS: NavGroup[] = [
  {
    key: 'logistica',
    label: 'Logística y Compras',
    icon: 'inventory_2',
    color: '#006d3c',
    basePaths: ['/requirements', '/area-requirements', '/material-requirements', '/purchase-orders', '/area-purchase-orders', '/suppliers', '/visits', '/distributions'],
    modules: ['requirements', 'area-requirements', 'material-requirements', 'purchase-orders', 'area-purchase-orders', 'suppliers', 'visits', 'distributions'],
    children: [
      { label: 'Req. Agencias', icon: 'home_work', route: '/requirements', module: 'requirements' },
      { label: 'Req. Áreas', icon: 'groups', route: '/area-requirements', module: 'area-requirements' },
      { label: 'Req. Materiales', icon: 'inventory_2', route: '/material-requirements', module: 'material-requirements' },
      { label: 'Órdenes Agencias', icon: 'receipt_long', route: '/purchase-orders', module: 'purchase-orders' },
      { label: 'Órdenes Áreas', icon: 'assignment', route: '/area-purchase-orders', module: 'area-purchase-orders' },
      { label: 'Proveedores', icon: 'local_shipping', route: '/suppliers', module: 'suppliers' },
      { label: 'Visitas', icon: 'directions_car', route: '/visits', module: 'visits' },
      { label: 'Distribuciones', icon: 'forklift', route: '/distributions', module: 'distributions' },
    ],
  },
  {
    key: 'cripto',
    label: 'Cripto Money',
    icon: 'currency_bitcoin',
    color: '#eab308',
    basePaths: ['/cripto-money'],
    modules: ['crypto-dashboard', 'crypto-operations', 'crypto-customers', 'crypto-exchange-rates', 'crypto-cash-drawer', 'crypto-wallets', 'crypto-currencies', 'crypto-billing', 'crypto-config', 'crypto-reports'],
    children: [
      { label: 'Dashboard', icon: 'dashboard', route: '/cripto-money', module: 'crypto-dashboard', exact: true },
      { label: 'Operaciones', icon: 'swap_horiz', route: '/cripto-money/operations', module: 'crypto-operations' },
      { label: 'Clientes', icon: 'people', route: '/cripto-money/customers', module: 'crypto-customers' },
      { label: 'Tipo de Cambio', icon: 'trending_up', route: '/cripto-money/exchange-rates', module: 'crypto-exchange-rates' },
      { label: 'Caja', icon: 'account_balance_wallet', route: '/cripto-money/cash-drawer', module: 'crypto-cash-drawer' },
      { label: 'Liquidaciones', icon: 'receipt', route: '/cripto-money/liquidaciones', module: 'crypto-cash-drawer' },
      { label: 'Billeteras', icon: 'wallet', route: '/cripto-money/wallets', module: 'crypto-wallets' },
      { label: 'Monedas', icon: 'paid', route: '/cripto-money/currencies', module: 'crypto-currencies' },
      { label: 'Facturación', icon: 'description', route: '/cripto-money/billing', module: 'crypto-billing' },
      { label: 'Configuración', icon: 'settings', route: '/cripto-money/config', module: 'crypto-config' },
      { label: 'Reportes', icon: 'bar_chart', route: '/cripto-money/reports', module: 'crypto-reports' },
    ],
  },
  {
    key: 'tesoreria',
    label: 'Tesorería',
    icon: 'account_balance',
    color: '#ef7c0a',
    basePaths: ['/monnet', '/boleteo'],
    modules: ['monnet-create', 'monnet-history', 'boleteo-create', 'boleteo-history'],
    children: [
      { label: 'Nuevo Payout', icon: 'add_circle', route: '/monnet/create', module: 'monnet-create' },
      { label: 'Historial Payouts', icon: 'history', route: '/monnet/history', module: 'monnet-history' },
      { label: 'Nuevo Boleteo', icon: 'note_add', route: '/boleteo/create', module: 'boleteo-create' },
      { label: 'Historial Boleteo', icon: 'history', route: '/boleteo/history', module: 'boleteo-history' },
    ],
  },
  {
    key: 'gestion-humana',
    label: 'Gestión Humana',
    icon: 'badge',
    color: '#ec4899',
    basePaths: ['/dashboard-intra', '/rrhh'],
    modules: ['dashboard-intra', 'rrhh-attendance', 'rrhh-employees', 'rrhh-shifts'],
    children: [
      { label: 'Intra', icon: 'vpn_key', route: '/dashboard-intra', module: 'dashboard-intra' },
      { label: 'Asistencia', icon: 'event_available', route: '/rrhh', module: 'rrhh-attendance', exact: false },
    ],
  },
  {
    key: 'marketing',
    label: 'Marketing',
    icon: 'campaign',
    color: '#f97316',
    basePaths: ['/dashboard-sorteo', '/dashboard-clientes', '/warehouses', '/reward-categories', '/rewards', '/my-stock', '/agencies-stock', '/customers', '/redeems'],
    modules: ['dashboard-sorteo', 'dashboard-clientes', 'warehouses', 'reward-categories', 'rewards', 'my-stock', 'agencies-stock', 'customers', 'redeems'],
    children: [
      { label: 'Sorteo', icon: 'redeem', route: '/dashboard-sorteo', module: 'dashboard-sorteo' },
      { label: 'Clientes Frecuentes', icon: 'loyalty', route: '/dashboard-clientes', module: 'dashboard-clientes' },
      { label: 'Almacén', icon: 'warehouse', route: '/warehouses', module: 'warehouses' },
      { label: 'Categorías Premio', icon: 'category', route: '/reward-categories', module: 'reward-categories' },
      { label: 'Premios', icon: 'emoji_events', route: '/rewards', module: 'rewards' },
      { label: 'Mi Stock', icon: 'inventory', route: '/my-stock', module: 'my-stock' },
      { label: 'Stock de Agencias', icon: 'store', route: '/agencies-stock', module: 'agencies-stock' },
      { label: 'Clientes', icon: 'people', route: '/customers', module: 'customers' },
      { label: 'Canjes', icon: 'card_giftcard', route: '/redeems', module: 'redeems' },
    ],
  },
  {
    key: 'mantenimiento',
    label: 'Mantenimiento',
    icon: 'build',
    color: '#0ea5e9',
    basePaths: ['/maintenance'],
    modules: ['maintenance-equipment', 'maintenance-maintenances', 'maintenance-alerts', 'maintenance-costs', 'maintenance-types'],
    children: [
      { label: 'Equipos', icon: 'devices', route: '/maintenance/equipment', module: 'maintenance-equipment' },
      { label: 'Mantenimientos', icon: 'engineering', route: '/maintenance/maintenances', module: 'maintenance-maintenances' },
      { label: 'Alertas', icon: 'notifications_active', route: '/maintenance/alerts', module: 'maintenance-alerts' },
      { label: 'Costos', icon: 'bar_chart', route: '/maintenance/cost-summary', module: 'maintenance-costs' },
      { label: 'Tipos de Equipo', icon: 'list', route: '/maintenance/equipment-types', module: 'maintenance-types' },
    ],
  },
  {
    key: 'metricas',
    label: 'Métricas',
    icon: 'analytics',
    color: '#8b5cf6',
    basePaths: ['/metrics'],
    modules: ['metrics-dashboard', 'metrics-agencies', 'metrics-operations', 'metrics-western-union', 'metrics-clients', 'metrics-operators', 'metrics-cambistas', 'metrics-cf', 'metrics-alertas-tc', 'metrics-cross-sell', 'metrics-mapa-calor', 'metrics-resultados'],
    children: [
      { label: 'Resumen', icon: 'dashboard', route: '/metrics', module: 'metrics-dashboard', exact: true },
      { label: 'Agencias', icon: 'business', route: '/metrics/agencies', module: 'metrics-agencies' },
      { label: 'Operaciones', icon: 'show_chart', route: '/metrics/operations', module: 'metrics-operations' },
      { label: 'Western Union', icon: 'public', route: '/metrics/western-union', module: 'metrics-western-union' },
      { label: 'Clientes', icon: 'people', route: '/metrics/clients', module: 'metrics-clients' },
      { label: 'Operadores', icon: 'badge', route: '/metrics/operators', module: 'metrics-operators' },
      { label: 'Cambistas', icon: 'currency_exchange', route: '/metrics/cambistas', module: 'metrics-cambistas' },
      { label: 'Cliente Frecuente', icon: 'star', route: '/metrics/cliente-frecuente', module: 'metrics-cf' },
      { label: 'Alertas TC', icon: 'warning', route: '/metrics/alertas-tc', module: 'metrics-alertas-tc' },
      { label: 'Cross-Sell', icon: 'sync', route: '/metrics/cross-sell', module: 'metrics-cross-sell' },
      { label: 'Mapa de Calor', icon: 'map', route: '/metrics/mapa-calor', module: 'metrics-mapa-calor' },
      { label: 'Resultados', icon: 'leaderboard', route: '/metrics/resultados', module: 'metrics-resultados' },
    ],
  },
  {
    key: 'conciliaciones',
    label: 'Conciliaciones',
    icon: 'account_balance',
    color: '#14b8a6',
    basePaths: ['/conciliaciones'],
    modules: ['conciliaciones-dashboard', 'conciliaciones-uploads', 'conciliaciones-transactions', 'conciliaciones-assignments', 'conciliaciones-accounts', 'conciliaciones-reports', 'conciliaciones-catalogs'],
    children: [
      { label: 'Dashboard', icon: 'dashboard', route: '/conciliaciones', module: 'conciliaciones-dashboard', exact: true },
      { label: 'Carga Archivos', icon: 'upload_file', route: '/conciliaciones/uploads', module: 'conciliaciones-uploads' },
      { label: 'Transacciones', icon: 'list_alt', route: '/conciliaciones/transactions', module: 'conciliaciones-transactions' },
      { label: 'Asignaciones', icon: 'assignment_ind', route: '/conciliaciones/assignments', module: 'conciliaciones-assignments' },
      { label: 'Cuentas', icon: 'account_balance_wallet', route: '/conciliaciones/accounts', module: 'conciliaciones-accounts' },
      { label: 'Reportes', icon: 'assessment', route: '/conciliaciones/reports', module: 'conciliaciones-reports' },
      { label: 'Catálogos', icon: 'label', route: '/conciliaciones/catalogs', module: 'conciliaciones-catalogs' },
    ],
  },
  {
    key: 'cumplimiento',
    label: 'Cumplimiento',
    icon: 'verified_user',
    color: '#6366f1',
    basePaths: ['/cumplimiento'],
    modules: ['cumplimiento-cambistas'],
    children: [
      { label: 'Cambistas', icon: 'people', route: '/cumplimiento/cambistas', module: 'cumplimiento-cambistas' },
    ],
  },
  {
    key: 'proyectos',
    label: 'Proyectos',
    icon: 'work',
    color: '#3b82f6',
    basePaths: ['/projects'],
    modules: ['projects'],
    children: [
      { label: 'Mis Proyectos', icon: 'folder', route: '/projects', module: 'projects', exact: true },
      { label: 'Mis Tareas', icon: 'task_alt', route: '/projects/my-tasks', module: 'projects' },
      { label: 'Cronogramas', icon: 'view_timeline', route: '/projects/cronogramas', module: 'projects-cronogramas' },
    ],
  },
  {
    key: 'informacion',
    label: 'Gestión Agencias',
    icon: 'apartment',
    color: '#10b981',
    basePaths: ['/informacion'],
    modules: ['informacion', 'informacion-admin'],
    children: [
      { label: 'Red Nacional', icon: 'location_on', route: '/informacion/agencias', module: 'informacion' },
      { label: 'Administrar', icon: 'settings', route: '/informacion/agencias-admin', module: 'informacion-admin' },
    ],
  },
  {
    key: 'configuracion',
    label: 'Configuración',
    icon: 'settings',
    color: '#64748b',
    basePaths: ['/cost-centers', '/budgets', '/users', '/role-modules', '/system-catalogs', '/sync-users', '/sync-agencies', '/api-keys'],
    modules: ['cost-centers', 'budgets', 'users', 'role-modules', 'system-catalogs', 'sync-users', 'sync-agencies', 'api-keys'],
    children: [
      { label: 'Centros de Costo', icon: 'account_balance_wallet', route: '/cost-centers', module: 'cost-centers' },
      { label: 'Presupuestos', icon: 'bar_chart', route: '/budgets', module: 'budgets' },
      { label: 'Usuarios', icon: 'group', route: '/users', module: 'users' },
      { label: 'Permisos', icon: 'lock', route: '/role-modules', module: 'role-modules' },
      { label: 'Catálogos', icon: 'list', route: '/system-catalogs', module: 'system-catalogs' },
      { label: 'Sync Usuarios', icon: 'sync', route: '/sync-users', module: 'sync-users' },
      { label: 'Sync Agencias', icon: 'business', route: '/sync-agencies', module: 'sync-agencies' },
      { label: 'API Keys', icon: 'vpn_key', route: '/api-keys', module: 'api-keys' },
    ],
  },
];

/** Find which group the current URL belongs to */
export function findActiveGroup(url: string): NavGroup | null {
  return NAV_GROUPS.find(g => g.basePaths.some(bp => url.startsWith(bp))) ?? null;
}
